import axios from "axios";
import { useQuery } from "react-query";

function useFacialSnapshot(facialDetails?: {
  snapshotUrl: string;
  login: string;
  senha: string;
}) {
  return useQuery(
    [`/intelbras/snapshot`, facialDetails],
    async () => {
      if (!facialDetails) return null;

      // Essa porta é do proxy
      const { data } = await axios.post<{ snapshot: string }>(
        "http://localhost:3030/get-snapshot",
        {
          login: facialDetails.login,
          senha: facialDetails.senha,
          snapshotUrl: facialDetails.snapshotUrl,
        }
      );

      return data.snapshot;
    },
    {
      enabled: !!facialDetails,
      refetchInterval: 3000,
    }
  );
}

export default useFacialSnapshot;
